import React from "react";
import { BreadCrumb } from "primereact/breadcrumb";
import { useSelector } from "react-redux";
import "./BreadCrumbMenu.scss";
import { Link, useLocation } from "react-router-dom";
import { camelCaseToTitle, isRtl } from "src/utils/helpers";
import { IBreadCrumbItem } from "src/redux/slices/breadCrumbSlice";
import { RoutePaths } from "src/resources/enum";
import { useTranslation } from "react-i18next";

const BreadCrumbMenu = () => {
  const { t } = useTranslation(["common", "registration"]);
  const home = {
    template: () => <Link to={RoutePaths.Home}>{t("home")}</Link>,
  };
  const dashboard = {
    template: () => <Link to={RoutePaths.Dashboard}>{t("dashboard")}</Link>,
  };
  const location = useLocation();
  const language = useSelector((state: any) => state.lookup.language);
  const breadCrumbItems = useSelector(
    (state: any) => state.breadCrumb.breadCrumbItems
  );
  const displayBreadCrumbs = breadCrumbItems.map((b: IBreadCrumbItem) => {
    return {
      ...b,
      template: () => (
        <Link to={b.routeTo}>
          {isRtl(language) ? t(b.label) : camelCaseToTitle(b.label)}
        </Link>
      ),
    };
  });
  const getHome = () => {
    const dashboardItems = [
      RoutePaths.ATECases,
      RoutePaths.MaintenanceRequests,
      RoutePaths.PreventiveAppointment,
      RoutePaths.AssignedBuildings,
      RoutePaths.ViewInvoices,
    ];
    if (location.pathname === RoutePaths.Dashboard) {
      return undefined;
    }
    if (dashboardItems.some((item) => location.pathname.includes(item))) {
      return dashboard;
    }
    return home;
  };
  return (
    <BreadCrumb
      model={displayBreadCrumbs}
      separatorIcon={<span>&nbsp;/&nbsp;</span>}
      home={getHome()}
      className="bread-crumb-menu"
    />
  );
};

export default BreadCrumbMenu;
